import { Divider, Stack, Typography } from "@mui/material";
import { Fragment, useState } from "react";
import DateRangePicker from "src/components/shared/DateRangePicker";
import DebtReportFileItem from "./DebtReportFileItem";
import useDebtReportList from "src/hooks/debt/useDebtReportList";
import { COMMOM_STATUS } from "src/constant";

const DebtReportFileList = () => {
  const [date, setDate] = useState({ fromDate: null, toDate: null });
  const { data } = useDebtReportList({
    fromDate: date?.fromDate ?? undefined,
    toDate: date?.toDate ?? undefined,
    limit: 1000,
  });

  return (
    <Stack sx={{ border: "1px solid #BDBDC6", borderRadius: "12px", p: 2 }}>
      <DateRangePicker
        value={date}
        onApply={setDate}
        label="Thời gian Xuất Báo Cáo"
      />
      <Typography
        fontWeight="bold"
        fontSize="16px"
        mt="14px"
      >
        Danh sách file đã xuất
      </Typography>
      <Divider sx={{ borderColor: "#E0E0E0", bgcolor: "#E0E0E0", my: "6px" }} />
      <Stack
        maxHeight="600px"
        overflow="auto"
        minHeight="600px"
      >
        {Array.isArray(data?.data) && data?.data?.length > 0 ? (
          data?.data
            .filter((item) => item.status === COMMOM_STATUS.done)
            .map((item) => (
              <Fragment key={item._id}>
                <DebtReportFileItem item={item} />
                <Divider sx={{ borderColor: "#E0E0E0", bgcolor: "#E0E0E0", my: "6px" }} />
              </Fragment>
            ))
        ) : (
          <Typography
            align="center"
            mt="20px"
          >
            Không có dữ liệu
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};

export default DebtReportFileList;
